// extracted by mini-css-extract-plugin
module.exports = {"InputText":"Input_InputText__rw68_","inputTextColor":"Input_inputTextColor__kJlDE","focused":"Input_focused__vk6HY"};